import React, { useState, useEffect, useRef } from "react";
import { Container, Button, Input } from "reactstrap";
import { Share2 } from "react-feather";
import copy from 'copy-to-clipboard';

import Ref1Img from '~/assets/images/referrals/ref1.png';
import Ref2Img from '~/assets/images/referrals/ref2.png';
import Ref3Img from '~/assets/images/referrals/ref3.png';

import Loader       from "~/components/loader";
import Msg          from "~/components/messages";
import OverlayModal from "~/components/overlayModal";

import Security from "~/services/security";
import User     from "~/services/user";
import List     from "./List";

const Referrals = ({})=> {

  const myReferralLink = `https://earn.do/${Security.currentUserValue.referralCode}`;

  const colors = [
    "#FF8080", "#B0ACFF", "#16E78F", "#24DCF6", "#BD00FF", "#00FF47", "#00D1FF", "#FF004D", "#E3BF00", "#FF0000"
  ];

  const referralBoxRef = useRef()

  const [disabled    , setDisabled]    = useState(false);
  const [loading     , setLoading]     = useState(true);
  const [overlayOpen , setOverlayOpen] = useState(false);

  const [referrals , setReferrals] = useState([]);
  const [user      , setUser]      = useState([]);

  useEffect(()=> {
    (async ()=> {
      const perPage = Math.floor((referralBoxRef.current.clientWidth * 0.66) / 50);
      setReferrals(await User.paginator.referrals({perPage}));
      setUser(await User.account());
      setLoading(false);
    })();
  }, []);

  const sendCode = ()=> {
    const shareData = {
      url   : myReferralLink,
      title : 'EarnDorado Invitation',
      text  : 'Use my referral link to sign up to EarnDorado and earn gift cards and cash.',
    };

    navigator.share(shareData).then(()=> {
      Msg.general("Invitation was sent!");
      setDisabled(true);
      setTimeout(()=> setDisabled(false), 2000);
    }).catch(console.log);
  };

  const referralInitials = (referral)=> {
    return `${referral.firstName.charAt(0)}${referral.lastName.charAt(0)}`.toUpperCase();
  };

  const getColor = (referral)=> {
    const code = referral.firstName.charCodeAt(0) + referral.lastName.charCodeAt(0);
    return colors[code % colors.length];
  };

  const copyReferralLink = ()=> {
    copy(myReferralLink);
    setDisabled(true);
    setTimeout(()=> setDisabled(false), 2000);
    Msg.copy("Referral code");
  };

  return (
    <Container fluid={true} className="page-referrals">

      <div className="share-box">
        <h5>Share your code and earn up to 300 points</h5>

        <div className="ref-input">
          <Input type="text" readOnly defaultValue={myReferralLink} />
          <Button color="primary" onClick={copyReferralLink} > Copy Link</Button>
        </div>

        { Boolean(navigator.share) && (
          <>
            <p> or share using your favorite social platforms </p>

            <button className="share-btn" onClick={sendCode} disabled={disabled}>
              <Share2 /> Share
            </button>
            </>
        )}
      </div>

      <div className="referral-box" ref={referralBoxRef}>

        <h3>Referrals</h3>
        { loading && <Loader type={19} size={40} center /> }

        { !referrals.length && !loading ? <p className="text-center text-muted m-0"> You currenty have no referrals! </p> : null }

        { referrals.length && !loading  ? <div className="d-flex">
          <div>

            { referrals.map((referral)=> (
              <span key={referral.id} className="initials" style={{backgroundColor: getColor(referral) }}> { referralInitials(referral) }  </span>
            ))}
          </div>
          <button onClick={()=> setOverlayOpen(true)}> See All {user.totalReferrals > referrals.length ? user.totalReferrals : ''} </button>
        </div> : null }

      </div>

      <h1>How It Works</h1>

      <div className="how-it-works">
        <ul>
          <li>
            <img src={Ref1Img} />
            <p> Your friend successfully registers to Earndorado, you get <span> 30 points </span>  </p>
          </li>
          <li>
            <img src={Ref2Img} />
            <p> Your friend completes the first offer You  get an extra <span> 270 points </span>  </p>
          </li>
          <li>
            <img src={Ref3Img} />
            <p>Your friend signs up using your link He gets a bonus of <span> 200 points </span> </p>
          </li>
        </ul>
      </div>

      <OverlayModal opened={overlayOpen} title="Referrals" onClose={()=>setOverlayOpen(false)}>
        <List referralInitials={referralInitials} getColor={getColor} />
      </OverlayModal>

    </Container>
  );
};

export default Referrals;
